import React, { useState } from 'react';
import { Layout } from 'antd';
import './MapView.scss';
import ExpandedMapView from '../ExpandedMapView';
import MapUploadFlow from '../UploadData/MapUploadFlow';
import { useLegendForm } from '../../../context/MapLegendContext';
import { useParams } from 'react-router-dom';

const { Content } = Layout;

const MapView: React.FC = () => {
  const [isDataPortalModalVisible, setIsDataPortalModalVisible] = useState<boolean>(false);
  const [_, setIsNewMap] = useState<boolean>(false);
  const { folderId } = useLegendForm();
  const { id } = useParams();

  return (
    <>
      <Content className="map-content">
        <ExpandedMapView
          isNewMap={id === 'new-map'}
          expandedCard={`${id}`}
          setIsNewMap={setIsNewMap}
          isDataPortalModalVisible={isDataPortalModalVisible}
          setIsDataPortalModalVisible={setIsDataPortalModalVisible}
          folderId={folderId}
        />
      </Content>

      <MapUploadFlow isDataPortalModalVisible={isDataPortalModalVisible} setIsDataPortalModalVisible={setIsDataPortalModalVisible} />
    </>
  );
};

export default MapView;
